import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
type MediaType = {
  type: 'image' | 'video';
  url: string;
};
interface CaseItemProps {
  title: string;
  description: string;
  media: MediaType;
  isActive: boolean;
  index: number;
}
const CaseItem = ({
  title,
  description,
  media,
  isActive,
  index
}: CaseItemProps) => {
  const [mediaKey, setMediaKey] = useState(Date.now());
  useEffect(() => {
    // Force reload of media when isActive changes to ensure GIFs play properly
    if (isActive) {
      setMediaKey(Date.now());
    }
  }, [isActive]);

  // Add a cache-busting parameter to the media URL
  const mediaUrl = `${media.url}?v=${mediaKey}`;
return (
    <div className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-white via-blue-50/30 to-purple-50/20 p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-[1.02] border border-white/50 backdrop-blur-sm">
      {/* Floating decorative elements */}
      <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-primary/10 to-purple-500/10 rounded-full blur-xl opacity-60 group-hover:opacity-80 transition-opacity duration-500"></div>
      <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-gradient-to-tr from-blue-500/10 to-primary/10 rounded-full blur-lg opacity-40 group-hover:opacity-60 transition-opacity duration-500"></div>
      
      <div className="relative z-10 flex flex-col lg:flex-row gap-6 lg:gap-8 h-full">
        {/* Content Section */}
        <div className="flex-1 flex flex-col justify-center order-2 lg:order-1">
          <div className="mb-4">
            <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4">
              Funzionalità #{index + 1}
            </div>
            <h3 className="text-2xl lg:text-3xl font-bold mb-4 text-gray-900 leading-tight">
              {title}
            </h3>
          </div>
          
          <div className="text-gray-700 text-lg leading-relaxed space-y-3">
            {description.split('.').filter(sentence => sentence.trim()).map((sentence, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <div className="w-2 h-2 bg-gradient-to-r from-primary to-purple-500 rounded-full mt-3 flex-shrink-0"></div>
                <p className="flex-1">{sentence.trim()}.</p>
              </div>
            ))}
          </div>
        </div>
        
        {/* Media Section */}
        <div className="flex-1 flex justify-center items-center order-1 lg:order-2 min-h-[300px] lg:min-h-[400px]">
          <div className="relative group-hover:scale-105 transition-transform duration-500">
            {/* Glowing background effect */}
            <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 via-purple-500/20 to-blue-500/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
            
            <div className="relative">
              {media.type === 'video' ? (
                <video 
                  src={mediaUrl} 
                  autoPlay 
                  loop 
                  muted 
                  className="w-full max-w-[350px] lg:max-w-[450px] h-auto object-contain rounded-2xl shadow-xl" 
                  key={`video-${mediaKey}`} 
                />
              ) : (
                <img 
                  src={mediaUrl} 
                  alt={title} 
                  className="w-full max-w-[320px] lg:max-w-[400px] h-auto object-contain rounded-2xl shadow-xl" 
                  key={`img-${mediaKey}`} 
                  loading="eager" 
                  onError={e => console.error("Image failed to load:", media.url, e)} 
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CaseItem;